

























































































import { Component } from 'vue-property-decorator';
import SingleActivityBox from './SingleActivityBox';
import BoxFooter from '@/modules/calendar/components/locations/BoxFooter.vue';

@Component({
    name: 'SingleActivityBig',
    components: {
        BoxFooter,
    },
})
export default class SingleActivityBig extends SingleActivityBox {
    private get visibility() {
        return this.componentsVisibility.calendar.locations.SingleActivityBig;
    }

    private get showShortId() {
        return this.visibility.ShortId ?? true;
    }

    private get showStartDate() {
        return this.visibility.StartDate ?? true;
    }

    private get showStartTime() {
        return this.visibility.StartTime ?? true;
    }

    private get showAddress() {
        return this.visibility.Address ?? true;
    }

    private get showAdvancedLevel() {
        return this.visibility.AdvanceLevel ?? true;
    }

    private get showStatus() {
        return this.visibility.ShortId ?? true;
    }

    private get showGroupDanceStyle() {
        return this.visibility.GroupDanceStyle ?? true;
    }
}
